import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, useAttrs, defineAsyncComponent, ref  } from "vue";
import { IonModal, IonHeader, IonToolbar, IonTitle, IonFooter, IonButtons, IonButton,IonIcon,IonContent, IonList} from '@ionic/vue';
import { chevronBackOutline, close} from "ionicons/icons";
import { showConfirm, loading}  from "@/plugins/interfaceControler";
import {startScan, stopScan, showScan} from  "@/plugins/scanControler";

export default /*#__PURE__*/_defineComponent({
  __name: 'mainForm',
  props: {
        show: Boolean,
        model: {
            type: String,
            required: true
        },
        title: {
          type: String,
          default: "Formulier"
        },
        modelValue: {
            type: Object,
            required: true
        },
        labelSave: {
          type: String,
          default: "Opslaan"
        },
        modal: {
            type: Boolean
        },
        list: {
          type: Array
        }
      },
  emits: ['close', 'save','delete', 'update:modelValue'],
  setup(__props, { emit }) {

const props:any = __props;

const attrs = useAttrs()



const record = computed({
  get () {
    return props.modelValue || {}
  },

  set (value) {
    return emit('update:modelValue', value)
  }
})
stopScan()
function refresh(title:string){
  pageTitle.value = title

}
const formComponent = defineAsyncComponent(() => import(`./${props.model}Form.vue`))
const oldValue = {...props.modelValue}
//inherit from formComponent
const formModel:any = ref(null)
const saving = ref(false)
const pageTitle = ref(props.title)
setTimeout(()=>{
  setTitle()
},200)

function setTitle(){
  if (record.value) pageTitle.value =  formModel.value?.pageTitle || ((record.value && record.value.display_name) ? record.value.display_name : props.title)
}
 

async function saveMe() {
    loading.value = true
    if (!formModel.value.isValid) return false
    saving.value = true
    const val = await formModel.value.saveModel(props.list)
    
    if (val){
        emit('save', val)
        closeMe() 
    } else{
        console.log('Error')
    }
    saving.value = false
}

function deleteMe(){
    let warning = "Wilt u " + formModel.value?.pageTitle + " verwijderen?"
    let tTitle = 'Verwijderen'
    if(props.model == 'user') {
      tTitle = 'LET OP: Verwijderen!'
      warning = 'Zorg ervoor dat er geen procuraties en vervangers meer open staan voor deze gebruiker. Wilt u doorgaan om deze gebruiker te verwijderen met alle gekoppelde kostenplaatsen?'
    }
    showConfirm(tTitle,warning, function (){
        if (formModel.value?.deleteModel()){
            emit('delete', record.value)
            closeMe() 
        }
    })
}
function cancel() {
    emit('update:modelValue', oldValue) //reset
    if (record.value && !record.value.id) record.value = null
    closeMe()
}
function closeMe() {
    emit('close');
    setTimeout(()=>loading.value=false,2000)
    if (showScan.value) startScan()
}

function back(){
  record.value.ticket_type_id = null
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    "is-open": __props.show,
    class: "footer header",
    "backdrop-dismiss": !__props.modal
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(pageTitle.value || 'Formulier'), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          (_unref(record))
            ? (_openBlock(), _createBlock(_unref(formComponent), {
                key: 0,
                modelValue: _unref(record),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(record) ? (record).value = $event : null)),
                ref_key: "formModel",
                ref: formModel,
                onRefresh: refresh,
                list: __props.list
              }, null, 8, ["modelValue", "list"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              (_unref(record).id && (_unref(attrs).delete==='' || _unref(attrs).delete===true))
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 0,
                    slot: "start",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteMe())),
                    fill: "clear",
                    color: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Verwijderen")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.list)
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 1,
                    slot: "end",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (saveMe()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bijwerken(" + _toDisplayString(__props.list.length) + ")", 1)
                    ]),
                    _: 1
                  }))
                : (_unref(record).id)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 2,
                      slot: "end",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (saveMe())),
                      disabled: saving.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.labelSave), 1),
                        (__props.list)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("(" + _toDisplayString(__props.list.length) + ")", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 3,
                      slot: "end",
                      disabled: _unref(loading),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (saveMe()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.labelSave), 1),
                        (__props.list)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("(" + _toDisplayString(__props.list.length) + ")", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["is-open", "backdrop-dismiss"]))
}
}

})